module.exports = __webpack_public_path__ + "button-product.svg?c26fd34bd52761c10eddf386218d7440";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button-product.svg
// module id = 569
// module chunks = 0